var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusCompletedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a49dqksmwa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 398",
    transform: "translate(6442 1708)",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-542 -449)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 25",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(542 449)",
    style: {
      fill: "#22b12d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 2",
    transform: "translate(-5900 -1259)",
    style: {
      clipPath: "url(#a49dqksmwa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 61570",
    d: "M21.538 12.308a9.231 9.231 0 1 0-9.231 9.231 9.233 9.233 0 0 0 9.231-9.231z",
    style: {
      stroke: "#22b12d",
      strokeMiterlimit: 10,
      fill: "none",
      strokeWidth: "1.538px"
    },
    transform: "translate(6439.692 1705.692)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 61571",
    d: "m16.923 8.462-6.462 7.692-2.769-3.077",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      strokeWidth: "1.538px"
    },
    transform: "translate(6439.692 1705.692)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCompletedIcon);
export default __webpack_public_path__ + "static/media/Status-completed-Icon.c789f4f0cae2ae0663e650cfa9986cb2.svg";
export { ForwardRef as ReactComponent };